import { render, staticRenderFns } from "./FeatureEditor.vue?vue&type=template&id=20bd6f56"
import script from "./FeatureEditor.vue?vue&type=script&lang=js"
export * from "./FeatureEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports